<div id="br-container">
    <toybr-calculation-form [carPriceBasis]="priceBasis"
                            [carPriceInterval]="priceInterval"
                            [servOn]="serverOnline"
                            [showSearch]="showSearchButton"
                            [style.font-size]="fontSize + 'em'">
    </toybr-calculation-form>
    <toybr-cookie-hint></toybr-cookie-hint>
</div>
